import {Box, Typography} from "@mui/material";
import {c, maxW, mono} from "../landingTokens";

const METRICS = [
  {value: "70", unit: "%", label: "of FAQs resolved with no human help"},
  {value: "<1", unit: "s", label: "to greet a caller — no hold time"},
  {value: "100", unit: "+", label: "customer intents understood out of the box"},
  {value: "24", unit: "/7", label: "multilingual coverage, zero downtime"},
];

// The hero's gradient-numeral device, reused so the stat wall reads as the same system.
const numberGradient = "linear-gradient(96deg, #6258E8 0%, #9A6EF5 52%, #C87CF0 100%)";

export const Metrics = () => (
  <Box component="section" data-screen-label="Metrics" sx={{position: "relative", overflow: "hidden", borderTop: `1px solid ${c.line}`, borderBottom: `1px solid ${c.line}`, px: {xs: 2.5, md: 4.5}, py: {xs: 8, md: 11}, bgcolor: c.bg, background: "radial-gradient(circle at 55% 100%, rgba(129,140,248,0.16), transparent 42%)"}}>
    <Box sx={{maxWidth: maxW, mx: "auto"}}>
      <Typography sx={{fontFamily: mono, fontSize: 11.5, letterSpacing: ".2em", textTransform: "uppercase", color: c.purpleDeep, mb: 2}}>Measured in production</Typography>
      <Typography component="h2" sx={{fontSize: "clamp(26px, 3.4vw, 40px)", fontWeight: 650, letterSpacing: "-0.035em", color: c.ink, maxWidth: 640, mb: {xs: 5, md: 6.5}}}>
        Numbers your customers actually feel.
      </Typography>

      <Box className="reveal-stagger" sx={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 200px), 1fr))", gap: {xs: 4, md: 5}}}>
        {METRICS.map((m) => (
          <Box key={m.label}>
            <Typography sx={{fontSize: "clamp(56px, 8vw, 86px)", fontWeight: 700, letterSpacing: "-0.07em", lineHeight: .9, background: numberGradient, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text"}}>
              {m.value}<Box component="span" sx={{fontSize: ".55em", ml: .35, letterSpacing: "-0.03em"}}>{m.unit}</Box>
            </Typography>
            {/* Short gradient accent bar instead of a full-width rule — softer, more refined. */}
            <Box sx={{height: "3px", width: 44, borderRadius: "3px", background: numberGradient, mt: 3, mb: 2.25}} />
            <Typography sx={{display: "block", fontSize: 14.5, color: "#5C5E6A", lineHeight: 1.55, maxWidth: 230}}>{m.label}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);
